<template>
  <div class="brief-container">
    <h2>中国话语与世界文学研究中心2024年度回顾</h2>
    <div class="brief-content">
      <p>
        中国话语与世界文学研究中心是上海外国语大学校级实体科研机构，以特色化、高端化、国际化为发展定位。2024年，在校党委及各级领导的关怀指导、上海全球治理与区域国别研究院的支持下，研究中心在学术创新、成果转化、人文交流、人才培养与话语传播等方面协同发展，积极助力我校构建融通中外的学术话语体系。
      </p>
      <div class="video-content">
        <div class="player-container">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
          </video-player>
        </div>
      </div>
      <!-- 一 -->
      <p style="text-align: center;">
        <strong class="title">一、学术创新，拓展研究领域</strong>
      </p>
      <p class="content">
        研究中心成员目前主持、在研各级科研课题共<strong style="color:#7b0c00">17</strong>项，2024年获批国家级与省部级科研和人才项目<strong style="color:#7b0c00">6</strong>项，包括国家资助博士后人员计划、教育部人文社会科学研究青年项目、教育部博士后人才项目、上海市哲学社会科学规划课题青年项目、上海市“晨光计划”等。
      </p>
      <img style="width:400px" src="../../../assets/images/2024/1.png" alt="" />
      <p class="content">
        研究中心成员在外国文学、比较文学、汉学研究等领域发表论文<strong style="color:#7b0c00">22</strong>篇，其中A&HCI与CSSCI来源期刊<strong style="color:#7b0c00">8</strong>篇，重要媒体文章<strong style="color:#7b0c00">6</strong>篇，<strong style="color:#7b0c00">1</strong>篇论文被人大复印资料全文转载。
      </p>
      <img style="width:560px" src="../../../assets/images/2024/2.png" alt="" />
      <br/>
      <img style="width:260px" src="../../../assets/images/2024/3.png" alt="" />

      <!-- 二 -->
      <p style="text-align: center;">
        <strong class="title">二、成果转化，彰显学术品牌</strong>
      </p>
      <p class="sub-title"><span>出版研究丛书，形成学术生产机制</span></p>
      <p class="content">
        “上海国别区域全球知识文库·中国话语与世界文学研究丛书”
        （丛书主编：张帆）第一辑共10部，由商务印书馆出版，2024年首推<strong style="color:#7b0c00">4</strong>部。
      </p>
    
      <img style="width:320px" src="../../../assets/images/2024/4.png" alt="" />
      <br/>
      <img  style="width:450px"   src="../../../assets/images/2024/5.png" alt="" />

      <p class="content">
        “中国文学海外译介研究丛书”（丛书主编：张帆、孙国亮）由上海大学出版社出版，2024年首推<strong style="color:#7b0c00">2</strong>部。
      </p>
      <img style="width:320px" src="../../../assets/images/2024/6.png" alt="" />
      <p class="content">研究中心博士后出版专著和译著共计<strong style="color:#7b0c00">3</strong>部。</p>
      <img style="width:400px" src="../../../assets/images/2024/7.png" alt="" />
      <p class="sub-title"><span>设立研究专栏，促进学术交流对话</span></p>
      <p class="content">
        研究中心依托教育部重大课题，在CSSCI来源期刊《国际汉学》开设特约专栏“中国故事的世界传播与流变”。
      </p>
      
      <img style="width:320px" src="../../../assets/images/2024/8.png" alt="" />
      <p  class="content">
        研究中心在综合性人文期刊《中国故事》开设固定专栏“中国故事的世界传播”。
      </p>
      <img style="width:640px" src="../../../assets/images/2024/9.png" alt="" />

      <p class="sub-title"><span>对标国家战略，提升学术应用价值</span></p>
      <p class="content">
        研究中心结合研究课题与成果，撰写并提交教育部社科司和外交部<strong style="color:#7b0c00">2</strong>篇咨政报告，发挥建言献策、经世致用的智库功能。
      </p>
      <p class="sub-title"><span>转化研究成果，推动学术话语传播</span></p>
      <p class="content">
        基于前期研究成果，“中国故事域外流变的视觉化呈现”课题组制作并推出“中国故事域外流变”的系列视频，共<strong style="color:#7b0c00">6</strong>辑。
      </p>
      <img style="width:680px" src="../../../assets/images/2024/10.png" alt="" />

      <!-- 三 -->
      <p style="text-align: center;">
        <strong class="title">三、人文交流，促进思想传播</strong>
      </p>
      <p class="content">
        2024年，研究中心主办<strong style="color:#7b0c00">3</strong>次国内学术会议，参会总人数近<strong style="color:#7b0c00">150</strong>人次。
      </p>
      <img style="width:760px" src="../../../assets/images/2024/11.png" alt="" />

      <p class="content">
        举办“国别区域全球知识前沿讲坛·中国话语与世界文学研究中心系列讲座”。
      </p>
      <img style="width:400px" src="../../../assets/images/2024/12.png" alt="" />

      <p class="content">
        开展“思想·诠释·对话：文学经典的跨文化旅行”主题系列读书会。
      </p>
      <img style="width:400px"  src="../../../assets/images/2024/13.png" alt="" />

      <p class="content">
        特邀德国、美国、奥地利、瑞士等国近<strong style="color:#7b0c00">10</strong>名专家进行实地驻访或开展线上交流。
      </p>
      <p class="content">
        研究中心成员受邀在国内高校及文化机构进行学术讲座<strong style="color:#7b0c00">11</strong>次。
      </p>
      <img style="width:840px"  src="../../../assets/images/2024/14.png" alt="" />

      <p class="content">研究中心成员参加国内外学术会议并宣读论文<strong style="color:#7b0c00">24</strong>篇。</p>
      <img style="width:860px" src="../../../assets/images/2024/15.png" alt="" />

      <!-- 四 -->
      <p style="text-align: center;">
        <strong class="title">四、学科建设，开设特色课程</strong>
      </p>
      <p class="content">
        2024年，研究中心成员开设<strong style="color:#7b0c00">3</strong>门硕博研究生公共选修课程：“记忆电影导论与赏析”、“莎士比亚戏剧研究”、“日本古典文学导论”，积极探索国别文学文化研究的特色课程。
      </p>
      <img style="width:760px" src="../../../assets/images/2024/16.png" alt="" />

      <!-- 五 -->
      <p style="text-align: center;">
        <strong class="title">五、人才培养，打造一流团队</strong>
      </p>
      <p class="content">
        目前研究中心共有<strong style="color:#7b0c00">6</strong>名科研人员，其中二级教授<strong style="color:#7b0c00">1</strong>人，副教授<strong style="color:#7b0c00">1</strong>人，博士后<strong style="color:#7b0c00">4</strong>人，覆盖英语、德语、日语、拉丁语等语种，成员均有海外知名高校留学或交流背景，研究方向包括外国语言文学、比较文学与世界文学、国别文化研究、海外汉学研究等。此外，研究中心建立起包括学术委员会、双聘教授、特聘研究员及兼职研究员的国内学术团队与人才梯队，并于2024年获批国家级外国专家人才项目<strong style="color:#7b0c00">2</strong>项。
      </p>
      <img style="width:600px" src="../../../assets/images/2024/17.png" alt="" />

      <!-- 六 -->
      <p style="text-align: center;">
        <strong class="title">六、话语传播，扩大社会影响</strong>
      </p>
      <p class="content">
        研究中心积极探索数字人文实践，建成并运行“世界文学‘中国故事’文献传播与研究”数据库，开发传播地图、关系图、统计图三大可视化平台。数据库建设集结国内<strong style="color:#7b0c00">10</strong>余所高校科研力量，团队<strong style="color:#7b0c00">300</strong>余人，已采集、录入逾<strong style="color:#7b0c00">10000</strong>条数据，涵盖<strong style="color:#7b0c00">39</strong>个语种，<strong style="color:#7b0c00">60</strong>个国家和地区。
      </p>
      <img style="width:640px" src="../../../assets/images/2024/18.png" alt="" />

      <p class="content">
        研究中心充分发挥新媒体作用，开发并上线官方网站，构建微信公众号、微信视频号、B站、小红书、抖音等社交媒体矩阵，微信公众号自上线以来已推送近<strong style="color:#7b0c00">300</strong>篇推文，其中原创推文<strong style="color:#7b0c00">123</strong>篇，累计订阅粉丝逾<strong style="color:#7b0c00">2500</strong>人，总阅读量近<strong style="color:#7b0c00">94700</strong>人次，单篇推文最高阅读量近<strong style="color:#7b0c00">3000</strong>人次。
      </p>
      <img style="width:740px" src="../../../assets/images/2024/19.png" alt="" />
      <img style="width:100%" src="../../../assets/images/2024/20.png" alt="" />
      <img style="width:100%" src="../../../assets/images/2024/22.png" alt="" />
      <img style="width:100%" src="../../../assets/images/2024/21.gif" alt="" />
      <img style="width:100%" src="../../../assets/images/2024/23.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
        sources: [
          {
            type: "video/mp4",
            src: "/cms/static/2024video.mp4", //url地址
          },
        ],
        poster: "/cms/static/2024video_poster.png", //你的封面地址
      },
    }
  },
  props: {},
  components: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.brief-container {
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }
 
  p {
    font-size: 16px;
    text-indent: 32px;
    color: #333;
    line-height: 32px;
    margin-bottom: 10px;
    .title {
      display: inline-block;
      color: #09386d;
      font-size:18px;
      padding:20px 0;
      text-indent: -32px;
    }
  
  }
  ::v-deep .vjs-poster {
    background-size: contain;
  }
  .video-content {
    text-align: center;
    margin: 14px 0;
  }
  .content {
    box-sizing: border-box;
    background-color: #eff4f8;
    padding: 20px 15px;
  }

  .sub-title {
    font-weight: 600;
    text-align: center;
    color: #09386d;
    text-indent: 0px;
    span {
      position: relative;
    }
    span::before,
    span::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      height: 4px; /* 边框的宽度 */
      background: linear-gradient(to right, #ecf2fa 36%, transparent 42%);
    }

    span::before {
      top: -10px; /* 上边框 */
    }

    span::after {
      bottom: -10px; /* 下边框 */
      background: linear-gradient(to right, transparent 46%, #ecf2fa 52%);
    }
  }
  img{
    position: relative;
    left:50%;
    transform: translateX(-50%);
    max-width:100%;
    margin: 12px 0 ;
  }
}

@media screen and (max-width: 768px) {
  .brief-container {
    h2 {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: #212529;
      margin-bottom: 20px;
    }
    p {
      font-size: 14px;
      text-indent: 28px;
      color: #333;
      line-height: 28px;
    }
    ::v-deep .vjs-poster {
      background-size: contain;
    }
    .video-content {
      text-align: center;
      margin: 14px 0;
    }
  }
}
</style>
